<div class="wrapper" *ngIf="visible">
    <div class="driver-modal p-3">
        <form (ngSubmit)="onSubmit()" #form="ngForm">
            <div class="form-group">
                <input
                    id="driver-first-name"
                    class="form-input"
                    name="driverFirstName"
                    type="text"
                    placeholder="First Name"
                    #driverFirstName="ngModel"
                    [(ngModel)]="data && data.firstName"
                    required
                />
                <label
                    for="driver-first-name"
                    class="form_label"
                >First Name
                </label>
                <div *ngIf="form.submitted && driverFirstName.invalid"
                    class="alert alert-danger">
                    <span>Field is required</span>
                </div>
            </div>
            <div class="form-group">
                <input
                    id="driver-last-name"
                    class="form-input"
                    name="driverLastName"
                    type="text"
                    placeholder="Last Name"
                    #driverLastName="ngModel"
                    [(ngModel)]="data && data.lastName"
                    required
                />
                <label
                    for="driver-last-name"
                    class="form_label"
                >Last Name
                </label>
                <div *ngIf="form.submitted && driverLastName.invalid"
                    class="alert alert-danger">
                    <span>Field is required</span>
                </div>
            </div>
            <div class="form-group">
                <input
                    id="driver-dob"
                    class="form-input"
                    name="driverDob"
                    type="date"
                    placeholder="Date of Birth"
                    #driverDob="ngModel"
                    [(ngModel)]="data && data.dateOfBirth"
                    required
                />
                <label
                    for="driver-dob"
                    class="form_label"
                >Date of Birth
                </label>
                <div *ngIf="form.submitted && driverDob.invalid"
                    class="alert alert-danger">
                    <span>Field is required</span>
                </div>
            </div>
            <div class="form-group">
                <input
                    id="driver-hire-date"
                    class="form-input"
                    name="driverHireDate"
                    type="date"
                    placeholder="Hire Date"
                    #driverHiredOn="ngModel"
                    [(ngModel)]="data && data.hiredOn"
                    required
                />
                <label
                    for="driver-hire-date"
                    class="form_label"
                >Hire Date
                </label>
                <div *ngIf="form.submitted && driverHiredOn.invalid"
                    class="alert alert-danger">
                    <span>Field is required</span>
                </div>
            </div>
            <div class="form-group">
                <input
                    id="driver-lic-state"
                    class="form-input"
                    name="driverLicState"
                    type="text"
                    placeholder="License State"
                    #driverLicState="ngModel"
                    [(ngModel)]="data && data.licensedState"
                    (ngModelChange)="data.licensedState = $event.toUpperCase()"
                    pattern="^[a-zA-Z]{2,2}$"
                    required
                />
                <label
                    for="driver-lic-state"
                    class="form_label"
                >License State
                </label>
                <div *ngIf="form.submitted && driverLicState.invalid"
                    class="alert alert-danger">
                    <span>Please enter valid state</span>
                </div>
            </div>
            <div class="form-group">
                <input
                    id="driver-lic-num"
                    class="form-input"
                    name="driverLicNum"
                    type="text"
                    placeholder="License Number"
                    #driverLicNum="ngModel"
                    [(ngModel)]="data && data.licenseNumber"
                    required
                />
                <label
                    for="driver-lic-num"
                    class="form_label"
                >License Number
                </label>
                <div *ngIf="form.submitted && (driverLicNum.errors && driverLicNum.errors['required'])"
                    class="alert alert-danger">
                    <span>Field is required</span>
                </div>
            </div>
            <div class="form-group">
                <input
                    id="driver-yde"
                    class="form-input"
                    name="driverYde"
                    type="number"
                    #driverYde="ngModel"
                    placeholder="Years Driving Experience"
                    min="0"
                    max="99"
                    [(ngModel)]="data && data.yearsDrivingExperience"
                    required
                />
                <label
                    for="driver-yde"
                    class="form_label"
                    >Years Driving Experience
                    </label>
                <div *ngIf="form.submitted && (driverYde.errors && driverYde.errors['required'])"
                    class="alert alert-danger">
                    <span>Field is required</span>
                </div>
                <div *ngIf="form.submitted && (driverYde.errors && (driverYde.errors['min'] || driverYde.errors['max']))"
                    class="alert alert-danger">
                    <span>Value can not be less than 0 and more than 99</span>
                </div>
            </div>
            <div class="form-group">
                <input
                    id="driver-term-date"
                    class="form-input"
                    name="driverTermDate"
                    type="date"
                    placeholder="Term Date"
                    [(ngModel)]="data && data.termDate"
                    (change)="handleDateChange($event)"
                />
                <label
                    for="driver-term-date"
                    class="form_label"
                >Term Date
                </label>
            </div>
            <div class="actions text-end">
                <button type="button" (click)="hide()" class="primary-button me-3">
                    Cancel
                </button>
                <button type="submit" class="primary-button">
                    Save
                </button>
            </div>
        </form>
    </div>
</div>
